import axiosInstance from "../../api/axios";

const ProductService = {
  getAllProducts: async () => {
    try {
      const response = await axiosInstance.get("/products");
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Failed to fetch products", error);
      return { success: false, error };
    }
  },

  syncProducts: async () => {
    try {
      const response = await axiosInstance.post("/save-all");
      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data.message || "Failed to sync products");
      }
    } catch (error) {
      console.error("Failed to sync products", error);
      throw error;
    }
  },
  getProductById: async (id) => {
    try {
      const response = await axiosInstance.get(`/products/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`Failed to fetch product with id ${id}`, error);
      return { success: false, error };
    }
  },
  getAssetById: async (id) => {
    try {
      const response = await axiosInstance.get(`/assets/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`Failed to fetch asset with id ${id}`, error);
      return { success: false, error };
    }
  },
  createContributor: async (assetId, contributorData) => {
    try {
      const response = await axiosInstance.post(
        `/assets/${assetId}/contributors`,
        contributorData
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.error(
        `Failed to create contributor for asset with id ${assetId}`,
        error
      );
      throw error;
    }
  },
  updateContributor: async ({id, formData}) => {
    try {
      const response = await axiosInstance.put(
        `/assets/contributors/${id}`,
        formData
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`Failed to update contributor with id ${id}`, error);
      throw error;
    }
  },

  deleteContributor: async (id) => {
    try {
      const response = await axiosInstance.delete(`/assets/contributors/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`Failed to delete contributor with id ${id}`, error);
      throw error;
    }
  },
  
  getRoyalties: async () => {
    try {
      const response = await axiosInstance.get("/royalties");
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Failed to fetch royalties", error);
      return { success: false, error };
    }
  },
};

export default ProductService;
